module.exports = __webpack_public_path__ + "img/emails.fe411222.png";